import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";

import { Switch, useTheme } from "@mui/material";

import { useAppContext } from "../../config/AppContext.js";

import {
  getArrayDocDataByRef,
  getDateFromFlutter,
  getDateFromSeconds,
  getFlutterTimeFromSeconds,
  queryCollection,
} from "../../models/DataFunctions.js";

import Tippy from "@tippyjs/react";
import { Spin } from "antd";
import Icon1 from "../../icons/Icon.js";
import DropDownGPT0X from "../../dropdowns/DropDownGTP0X.js";
import { hasInfiltro } from "../../hexagone/VisibilityHelpers.js";
import SmallSpinner from "../../loading/SmallSpinner.js";
import { queryFolders } from "../../models/AlgoliaFunctions.js";
import { EasySwitch } from "../../textfields/EasySwitch.js";
import { LineChart } from "../../components/charts/LineChart.jsx";
const MasterStats = ({ navigateWorkspace, orgData }) => {
  const theme = useTheme();
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  let saved_data = appState.saved_data;

  const [new_folders_per_month, setNew_folders_per_month] = useState([]);
  const [intervention_per_month, setIntervention_per_month] = useState([]);
  const [payments_per_month, setPayments_per_month] = useState([]);
  const [control_per_operator, setControl_per_operator] = useState([]);
  const [repartition_folders, setRepartition_folders] = useState([]);
  const [folders_per_client, setFolders_per_client] = useState([]);
  const [folders_client_type, setFolders_client_type] = useState([]);
  const [folders_origin, setFolders_origin] = useState([]);
  const [
    finalisation_time_error_correction,
    setFinalisation_time_error_correction,
  ] = useState(0.85);
  const [folders_per_expert, setFolders_per_expert] = useState([]);
  const [folders_per_structure, setFolders_per_structure] = useState([]);

  const [time_period, setTime_period] = useState("last12months");

  const [last_finalised_folders, setLast_finalised_folders] = useState([]);
  const [last_infiltrea_reports_imported, setLast_infiltrea_reports_imported] =
    useState([]);
  const [infiltreaSize, setInfiltreaSize] = useState(false);

  const [finalisation_time_per_month, setFinalisation_time_per_month] =
    useState([]);
  const [show_all_clients, setShow_all_clients] = useState(false);
  const [queried_objects, setQueriedObjects] = useState({
    folders: [],
    controls: [],
    devis: [],
    payments: [],
  });

  const [loaded, setLoaded] = useState(false);
  const [dict_stats, setDict_stats] = useState({});
  const [loadingTime, setLoadingTime] = useState(false);
  // Function to fetch user and organization data
  const handleFetchData = async (time_period, new_correction) => {
    setLoadingTime(true);
    if (orgData) {
      try {
        let date = new Date();

        let folders = [];
        if (queried_objects.folders.length > 0) {
          folders = queried_objects.folders;
        } else {
          folders = await queryFolders(null, orgData, []);
          setQueriedObjects((prev) => ({
            ...prev,
            folders: folders,
          }));
        }

        let firstDay = new Date(date.getFullYear(), 0, 1);
        let lastDay = new Date(date.getFullYear(), 11, 31);
        if (time_period === "last12months") {
          firstDay = new Date(
            date.getFullYear(),
            date.getMonth() - 11,
            date.getDate()
          );
          lastDay = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            23
          );

          folders = folders.filter((folder) => {
            let folder_date = getDateFromFlutter(folder.created_time);

            return folder_date >= firstDay && folder_date <= lastDay;
          });
        } else if (time_period === "thisyear") {
          firstDay = new Date(date.getFullYear(), 0, 1);
          lastDay = new Date(date.getFullYear(), 11, 31);

          folders = folders.filter((folder) => {
            let folder_date = getDateFromFlutter(folder.created_time);
            return folder_date >= firstDay && folder_date <= lastDay;
          });
        } else if (time_period === "lastyear") {
          firstDay = new Date(date.getFullYear() - 1, 0, 1);
          lastDay = new Date(date.getFullYear() - 1, 11, 31);

          folders = folders.filter((folder) => {
            let folder_date = getDateFromFlutter(folder.created_time);
            return folder_date >= firstDay && folder_date <= lastDay;
          });
        }
        let devis = [];
        if (queried_objects.controls.length > 0) {
          devis = queried_objects.devis;
        } else {
          let filters_devis = [
            {
              field: "org_id",
              operator: "==",
              value: orgData.id,
            },
          ];
          devis = await queryCollection("devis", filters_devis);
          setQueriedObjects((prev) => ({
            ...prev,
            devis: devis,
          }));
        }
        devis = devis.filter((devis) => {
          let devis_date = getDateFromSeconds(devis.creation_date?.seconds);
          return devis_date >= firstDay && devis_date <= lastDay;
        });

        let controls = [];
        if (queried_objects.controls.length > 0) {
          controls = queried_objects.controls;
        } else {
          let filters_controls = [
            {
              field: "org_id",
              operator: "==",
              value: orgData.id,
            },
          ];
          controls = await queryCollection("control", filters_controls);
          setQueriedObjects((prev) => ({
            ...prev,
            controls: controls,
          }));
        }

        // filter controls by date
        controls = controls.filter((control) => {
          let control_date = getDateFromSeconds(control.date?.seconds);
          return control_date >= firstDay && control_date <= lastDay;
        });
        let payments = [];
        if (queried_objects.payments.length > 0) {
          payments = queried_objects.payments;
        } else {
          let filters_payments = [
            {
              field: "master_id",
              operator: "==",
              value: orgData.id,
            },
          ];
          payments = await queryCollection("payment", filters_payments);
          setQueriedObjects((prev) => ({
            ...prev,
            payments: payments,
          }));
        }

        // filter controls by date
        payments = payments.filter((payment) => {
          let pay_date = getDateFromFlutter(
            payment.paid_date ||
              getFlutterTimeFromSeconds(payment.initiation_seconds || 0)
          );
          return pay_date >= firstDay && pay_date <= lastDay;
        });

        handleFetchFoldersStats(orgData, folders, firstDay, new_correction);
        handleFetchControlStats(orgData, controls);
        handleFetchClientsStats(orgData, folders);
        handleFetchExpertsStats(orgData, folders);
        handleFetchPaymentsStats(orgData, payments, firstDay);
        handleFetchFoldersStatsDict(orgData, folders, controls, devis);
        handleFetchInfiltrea(orgData);
        setLoaded(true);
        // Set the fetched user and organization data in state
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    setLoadingTime(false);
  };
  const handleGoRDVFolder = () => {
    let new_folders_confis = appState.folders_config;
    new_folders_confis.only_folder_filter = "rdv";
    setAppState((prevState) => ({
      ...prevState,
      folders_config: new_folders_confis,
    }));

    navigateWorkspace("/folders");
  };

  const handleGoLateFolder = () => {
    let new_folders_confis = appState.folders_config;
    new_folders_confis.only_folder_filter = "late";
    setAppState((prevState) => ({
      ...prevState,
      folders_config: new_folders_confis,
    }));

    navigateWorkspace("/folders");
  };

  function isFinalisedOrArchived(folder, orgDat = null) {
    let org_id = orgDat ? orgDat.id : orgData.id;
    return (
      folder.reglement_state === "done" ||
      folder.visions.find((vision) => vision.org_id === org_id)?.state ===
        "archived"
    );
  }

  const handleFetchFoldersStats = async (
    orgData,
    folders,
    firstDayYear,
    new_correction
  ) => {
    // I want to get the number of folders created per month
    let new_folders_per_month = [];
    let intervention_per_month = [];
    let finalisation_time_per_month = [];
    let max_count = 0;
    let max_intervention_count = 0;
    let max_finalisation_time = 0;
    let max_finalised_count = 0;
    let anchor_date = firstDayYear;
    // loop through each of the last 12 months and get the number of folders created
    for (let i = 0; i < 12; i++) {
      let firstDay = new Date(
        anchor_date.getFullYear(),
        anchor_date.getMonth() + i,
        1
      );
      let lastDay = new Date(
        anchor_date.getFullYear(),
        anchor_date.getMonth() + i + 1,
        0
      );

      let associated_folders = folders.filter((folder) => {
        let folder_date = getDateFromFlutter(folder.created_time);
        return folder_date >= firstDay && folder_date <= lastDay;
      });
      let associated_folders_realise = folders.filter((folder) => {
        if (!folder.dateintervention?.seconds) {
          return false;
        }
        let folder_date = getDateFromSeconds(folder.dateintervention?.seconds);
        return folder_date >= firstDay && folder_date <= lastDay;
      });
      let associated_folders_realisee_finalised =
        associated_folders_realise.filter((folder) => {
          return folder.reglement_state === "done";
        });

      if (associated_folders.length > max_count) {
        max_count = associated_folders.length;
      }

      new_folders_per_month.push({
        month: firstDay.toLocaleString("default", { month: "long" }),
        year: firstDay.getFullYear(),
        count: associated_folders.length,
      });
      intervention_per_month.push({
        month: firstDay.toLocaleString("default", { month: "long" }),
        year: firstDay.getFullYear(),
        count: associated_folders_realise.length,
      });
      let ten_perc_folders = Math.ceil(
        associated_folders_realisee_finalised.length * new_correction
      );
      finalisation_time_per_month.push({
        month: firstDay.toLocaleString("default", { month: "long" }),
        year: firstDay.getFullYear(),
        count_folders: ten_perc_folders,
        count_time: Math.round(
          associated_folders_realisee_finalised
            // i want to remove the 10% of the folders that took the longest time to finalise
            .sort((a, b) => {
              let a_time =
                a.finalised_date?.seconds -
                Math.max(a.dateintervention?.seconds, a.created_time?.seconds);
              let b_time =
                b.finalised_date?.seconds -
                Math.max(b.dateintervention?.seconds, b.created_time?.seconds);
              return a_time - b_time;
            })
            .slice(0, ten_perc_folders)

            .reduce((acc, folder) => {
              if (
                !folder.finalised_date?.seconds ||
                (!folder.dateintervention?.seconds &&
                  !folder.created_time?.seconds)
              ) {
                return acc;
              }
              let diff =
                folder.finalised_date?.seconds -
                Math.max(
                  folder.dateintervention?.seconds,
                  folder.created_time?.seconds
                );
              if (diff < 0) {
                return acc;
              }
              return acc + diff;
            }, 0) /
            (associated_folders_realisee_finalised.length * 60 * 60 * 24) || 0
        ),
      });
    }
    // finalisation_time_per_month =
    //   orgData.email === "rapport@ouestenergiecontrole.fr"
    //     ? finalisation_time_per_month.map((item, index) => {
    //         return {
    //           ...item,
    //           count_time: Math.round(
    //             item.count_time -
    //               (index === 11 ? 0 : index * 0.05 * item.count_time)
    //           ),
    //         };
    //       })
    //     : finalisation_time_per_month;
    max_finalisation_time = Math.max(
      ...finalisation_time_per_month.map((item) => item.count_time)
    );
    max_intervention_count = Math.max(
      ...intervention_per_month.map((item) => item.count)
    );
    max_finalised_count = Math.max(
      ...finalisation_time_per_month.map((item) => item.count_folders)
    );

    new_folders_per_month = new_folders_per_month.map((item) => {
      return {
        ...item,
        height: Math.round((item.count / max_count) * 80),
      };
    });

    intervention_per_month = intervention_per_month.map((item) => {
      return {
        ...item,
        height: Math.round((item.count / max_intervention_count) * 80),
      };
    });

    finalisation_time_per_month = finalisation_time_per_month.map((item) => {
      return {
        ...item,
        height_time: Math.round((item.count_time / max_finalisation_time) * 70),
        height_folders: Math.round(
          (item.count_folders / max_finalised_count) * 70
        ),
      };
    });

    let last_10_finalised_folders = folders

      .filter((folder) => folder.reglement_state === "done")
      .filter((folder) => folder.finalised_date)
      .sort((a, b) => b.finalised_date - a.finalised_date)
      .slice(0, 9);
    setLast_finalised_folders(last_10_finalised_folders);

    setNew_folders_per_month(new_folders_per_month);
    setIntervention_per_month(intervention_per_month);
    setFinalisation_time_per_month(finalisation_time_per_month);

    let current_folders = folders.filter(
      (folder) =>
        folder.visions?.find((vision) => vision.org_id === orgData.id)
          ?.state === "current"
    );
    let late_folders_count = current_folders.filter(
      (folder) => folder.late === true && !(folder.revisions?.length === 0)
    ).length;
    let revisited_folders_count = current_folders.filter(
      (folder) => folder.revisions?.length === 0
    ).length;
    let completed_folders_count = current_folders.filter(
      (folder) => folder.reglement_state === "done"
    ).length;
    let programmed_folders_count = current_folders.filter(
      (folder) => folder.intervention_realisee === false
    ).length;
    let realisee_folders_count = current_folders.filter(
      (folder) => folder.intervention_realisee === true
    ).length;
    let blocked_folders_count = current_folders.filter(
      (folder) => folder.blocked === true
    ).length;
    let modif_thermal_stuck_folders_count = current_folders.filter(
      (folder) =>
        folder.modif_thermal?.activated &&
        folder.modif_thermal?.state !== "done"
    ).length;
    let xml_stuck_folders_count = current_folders.filter(
      (folder) =>
        folder.modif_thermal?.activated && folder.xml?.state !== "done"
    ).length;
    let conformity_folders_count = current_folders.filter(
      (folder) => folder.conforme === false
    ).length;

    let maxx = Math.max(
      late_folders_count,
      revisited_folders_count,
      completed_folders_count,
      programmed_folders_count,
      blocked_folders_count,
      modif_thermal_stuck_folders_count,
      xml_stuck_folders_count,
      conformity_folders_count,
      realisee_folders_count
    );

    let repartition_folders = [
      {
        title: "Retard",
        count: late_folders_count,
        color: "#FF0000",
        height: Math.round((late_folders_count / maxx) * 100),
      },
      {
        title: "Revisite prévue",
        count: revisited_folders_count,
        color: "#6366f1",
        height: Math.round((revisited_folders_count / maxx) * 100),
      },
      {
        title: "Finalisé",
        count: completed_folders_count,
        color: "#14ef82",
        height: Math.round((completed_folders_count / maxx) * 100),
      },
      {
        title: "A venir",
        count: programmed_folders_count,
        color: "#6366f1",
        height: Math.round((programmed_folders_count / maxx) * 100),
      },
      {
        title: "Réalisé",
        count: realisee_folders_count,
        color: "#6366f1",
        height: Math.round((realisee_folders_count / maxx) * 100),
      },
      {
        title: "Bloqué",
        count: blocked_folders_count,
        color: "#FF0000",
        height: Math.round((blocked_folders_count / maxx) * 100),
      },
      {
        title: "Mise à jour thermique bloquante",
        count: modif_thermal_stuck_folders_count,
        color: "#6366f1",
        height: Math.round((modif_thermal_stuck_folders_count / maxx) * 100),
      },
      {
        title: "XML bloquant",
        count: xml_stuck_folders_count,
        color: "#6366f1",
        height: Math.round((xml_stuck_folders_count / maxx) * 100),
      },
      {
        title: "Non conforme",
        count: conformity_folders_count,
        color: "#6366f1",
        height: Math.round((conformity_folders_count / maxx) * 100),
      },
    ];
    repartition_folders = repartition_folders.sort((a, b) => b.count - a.count);
    setRepartition_folders(repartition_folders);

    let architect_folders_count = folders.filter(
      (folder) => folder.client_type === "architect"
    ).length;
    let constructor_folders_count = folders.filter(
      (folder) => folder.client_type === "constructor"
    ).length;
    let particulier_folders_count = folders.filter(
      (folder) => folder.client_type === "particulier"
    ).length;

    let max_client_type = Math.max(
      architect_folders_count,
      constructor_folders_count,
      particulier_folders_count
    );

    let folders_client_type = [
      {
        title: "Architecte",
        count: architect_folders_count,
        height:
          Math.round((architect_folders_count / max_client_type) * 100) || 0,
        color: "#898aeb",
      },
      {
        title: "Constructeur",
        count: constructor_folders_count,
        height:
          Math.round((constructor_folders_count / max_client_type) * 100) || 0,
        color: "#2d30f7",
      },
      {
        title: "Particulier",
        count: particulier_folders_count,
        height:
          Math.round((particulier_folders_count / max_client_type) * 100) || 0,
        color: "#6366f1",
      },
    ];
    folders_client_type = folders_client_type.sort((a, b) => b.count - a.count);
    setFolders_client_type(folders_client_type);

    let created_by_client_folders_count = folders.filter(
      (folder) => folder.author_id === folder.client_id
    ).length;
    let created_by_master_folders_count = folders.filter(
      (folder) => folder.author_id !== folder.client_id
    ).length;
    let created_from_devis_folders_count = folders.filter(
      (folder) => folder.invoices?.find((i) => i.ref)?.ref
    ).length;

    let max_origin = Math.max(
      created_by_client_folders_count,
      created_by_master_folders_count,
      created_from_devis_folders_count
    );

    let folders_origin = [
      {
        title: "Client",
        count: created_by_client_folders_count,
        height:
          Math.round((created_by_client_folders_count / max_origin) * 100) || 0,
        color: "#898aeb",
      },
      {
        title: "Infiltromètre",
        count: created_by_master_folders_count,
        height:
          Math.round((created_by_master_folders_count / max_origin) * 100) || 0,
        color: "#6366f1",
      },
      {
        title: "Devis",
        count: created_from_devis_folders_count,
        height:
          Math.round((created_from_devis_folders_count / max_origin) * 100) ||
          0,
        color: "#2d30f7",
      },
    ];
    folders_origin = folders_origin.sort((a, b) => b.count - a.count);
    setFolders_origin(folders_origin);
  };

  const handleFetchFoldersStatsDict = async (
    orgData,
    folders,
    controls,
    devis
  ) => {
    let finalised_folders = folders.filter(
      (folder) => folder.reglement_state === "done"
    );

    let realisee_finalised_folders = finalised_folders.filter(
      (folder) => folder.dateintervention?.seconds
    );

    let avg_finalisation_time = realisee_finalised_folders.reduce(
      (acc, folder) => {
        if (
          !folder.finalised_date?.seconds ||
          !folder.dateintervention?.seconds
        ) {
          return acc;
        }
        let diff =
          folder.finalised_date?.seconds -
          (folder.dateintervention?.seconds
            ? Math.max(
                folder.dateintervention?.seconds,
                folder.created_time?.seconds
              )
            : folder.created_time?.seconds);
        if (diff < 0) {
          return acc;
        }

        return acc + diff;
      },
      0
    );
    avg_finalisation_time =
      realisee_finalised_folders.length > 0
        ? avg_finalisation_time / realisee_finalised_folders.length
        : 0;
    let avg_finalisation_days = Math.floor(
      avg_finalisation_time / (60 * 60 * 24)
    );

    let avg_test_value = controls.reduce((acc, control) => {
      let mandatory_fields = control.cochamps.find(
        (champ) => champ.name === "Champs obligatoires"
      );
      if (!mandatory_fields) {
        return acc;
      }
      let test_champ = mandatory_fields.champs?.find(
        (champ) => champ.name === "Résultat test"
      );
      if (!test_champ) {
        return acc;
      }
      if (!test_champ.content) {
        return acc;
      }
      let test_value_string = test_champ.content[0];
      if (!test_value_string) {
        return acc;
      }

      let test_value = parseFloat(
        test_value_string.replace(" ", "").replace(",", ".").substring(0, 3)
      );

      if (isNaN(test_value) || test_value <= 0) {
        return acc;
      }
      return acc + test_value;
    }, 0);
    avg_test_value = avg_test_value / controls.length || 0;

    let perc_revisite =
      folders.length > 0
        ? (folders.filter((folder) => folder.revisions).length /
            folders.length) *
          100
        : 0;

    let revision_count = folders.filter((folder) => folder.revisions).length;

    let rdv_count = folders.filter(
      (folder) =>
        folder.dateintervention === null && folder.rdv_state === "wait"
    ).length;
    let done_devis_with_folder = devis.filter(
      (devis) => devis.state === "done" && devis.folder_ref
    ).length;
    let waiting_devis = devis.filter((devis) => devis.state === "wait").length;
    let done_no_folder_devis = devis.filter(
      (devis) => devis.state === "done" && !devis.folder_ref
    ).length;

    let notified_folders_count = folders.filter((folder) =>
      folder.notified_orgs_id?.includes(orgData.id)
    ).length;

    let late_folders_count = folders.filter(
      (folder) =>
        folder.late === true &&
        !(folder.revisions?.length === 0) &&
        folder.visions?.find((vision) => vision.org_id === orgData.id)
          ?.state === "current"
    ).length;

    let new_dict_stats = dict_stats;
    new_dict_stats["folders"] = folders.length;
    new_dict_stats["finalised_folders"] = finalised_folders.length;

    new_dict_stats["avg_finalisation_days"] = avg_finalisation_days;
    new_dict_stats["avg_test_value"] = avg_test_value;
    new_dict_stats["perc_revisite"] = perc_revisite;
    new_dict_stats["rdv_count"] = rdv_count;
    new_dict_stats["revision_count"] = revision_count;

    new_dict_stats["done_devis_with_folder"] = done_devis_with_folder;
    new_dict_stats["waiting_devis"] = waiting_devis;
    new_dict_stats["done_no_folder_devis"] = done_no_folder_devis;
    new_dict_stats["notified_folders_count"] = notified_folders_count;
    new_dict_stats["late_folders_count"] = late_folders_count;
    setDict_stats(new_dict_stats);
  };

  const handleFetchControlStats = async (orgData, controls) => {
    let filters_controls = [
      {
        field: "org_id",
        operator: "==",
        value: orgData.id,
      },
    ];
    let users = await queryCollection("user", filters_controls);
    let operators = users.filter((user) => user.role === "operator");
    // I want to get the number of folders created per month
    let control_per_operator = [];
    let max_count = 0;

    // loop through each of the last 12 months and get the number of folders created
    for (let i = 0; i < operators.length; i++) {
      let associated_controls = controls.filter((control) =>
        control.members_id?.includes(operators[i].id)
      );

      if (associated_controls.length > max_count) {
        max_count = associated_controls.length;
      }

      control_per_operator.push({
        name: operators[i].display_name,
        count: associated_controls.length,
      });
    }

    control_per_operator = control_per_operator.map((item) => {
      return {
        ...item,
        height:
          max_count > 0 ? Math.round((item.count / max_count) * 100) || 0 : 0,
      };
    });
    control_per_operator = control_per_operator.sort(
      (a, b) => b.count - a.count
    );
    setControl_per_operator(control_per_operator);
  };

  const handleFetchClientsStats = async (orgData, folders) => {
    let filters_clients = [
      {
        field: "masters_id",
        operator: "array-contains",
        value: orgData.id,
      },
    ];
    let clients = await queryCollection("org", filters_clients);

    // I want to get the number of folders created per month
    let folder_per_client = [];
    let max_count = 0;
    for (let i = 0; i < clients.length; i++) {
      let associated_folders1 = folders.filter(
        (folder) => folder.client_id === clients[i]?.id
      );
      let associated_folders2 = folders.filter((folder) =>
        folder.partners_id?.map((p) => p.id)?.includes(clients[i]?.id)
      );
      let associated_folders = [...associated_folders1, ...associated_folders2];
      if (associated_folders.length > max_count) {
        max_count = associated_folders.length;
      }
      folder_per_client.push({
        name: clients[i].name,
        count: associated_folders.length,
      });
    }

    folder_per_client = folder_per_client.map((item) => {
      return {
        ...item,
        height: max_count > 0 ? Math.round((item.count / max_count) * 100) : 0,
      };
    });
    folder_per_client = folder_per_client.sort((a, b) => b.count - a.count);
    // limit to max 15

    setFolders_per_client(folder_per_client);
  };

  const handleFetchPaymentsStats = async (orgData, payments, firstDayYear) => {
    // I want to get the number of folders created per month
    let pay_per_month = [];

    let max_amount_count = 0;

    let anchor_date = firstDayYear;
    // loop through each of the last 12 months and get the number of folders created
    for (let i = 0; i < 12; i++) {
      let firstDay = new Date(
        anchor_date.getFullYear(),
        anchor_date.getMonth() + i,
        1
      );
      let lastDay = new Date(
        anchor_date.getFullYear(),
        anchor_date.getMonth() + i + 1,
        0
      );

      let associated_payments = payments.filter((pay) => {
        let pay_date = getDateFromFlutter(
          pay.paid_date ||
            getFlutterTimeFromSeconds(pay.initiation_seconds || 0)
        );
        return (
          pay_date >= firstDay && pay_date <= lastDay && pay.state === "paid"
        );
      });

      let associated_payments_no_bridge = associated_payments.filter(
        (pay) => pay.bridge?.status !== "ACSC"
      );

      pay_per_month.push({
        month: firstDay.toLocaleString("default", { month: "long" }),
        year: firstDay.getFullYear(),
        bridge_count: associated_payments
          .filter((pay) => pay.bridge?.status === "ACSC")
          .reduce((acc, pay) => {
            if (pay.amount) {
              return acc + pay.amount;
            }
            return acc;
          }, 0),

        count: associated_payments.reduce((acc, pay) => {
          if (pay.amount) {
            return acc + pay.amount;
          }
          return acc;
        }, 0),
      });
    }
    max_amount_count = Math.max(...pay_per_month.map((item) => item.count));
    pay_per_month = pay_per_month.map((item) => {
      return {
        ...item,
        height: Math.round((item.count / max_amount_count) * 80),
        bridge_height: Math.round((item.bridge_count / max_amount_count) * 80),
      };
    });

    setPayments_per_month(pay_per_month);
  };

  const handleFetchExpertsStats = async (orgData, folders) => {
    let maison_individuelle_folders = folders.filter(
      (folder) => folder.structure_type === "maison_individuelle"
    ).length;
    let extension_folders = folders.filter(
      (folder) => folder.structure_type === "extension"
    ).length;
    let tertiaire_folders = folders.filter(
      (folder) => folder.structure_type === "tertiaire"
    ).length;
    let collectif_folders = folders.filter(
      (folder) => folder.structure_type === "collectif"
    ).length;

    let max_structure_type = Math.max(
      maison_individuelle_folders,
      extension_folders,
      tertiaire_folders,
      collectif_folders
    );

    let folders_structure_type = [
      {
        name: "Maison individuelle",
        count: maison_individuelle_folders,
        height:
          Math.round(
            (maison_individuelle_folders / max_structure_type) * 100
          ) || 0,
        color: "#4cb3e7",
      },
      {
        name: "Extension",
        count: extension_folders,
        height: Math.round((extension_folders / max_structure_type) * 100) || 0,
        color: "#3b82f6",
      },
      {
        name: "Tertiaire",
        count: tertiaire_folders,
        height: Math.round((tertiaire_folders / max_structure_type) * 100) || 0,
        color: "#c15ee8",
      },
      {
        name: "Collectif",
        count: collectif_folders,
        height: Math.round((collectif_folders / max_structure_type) * 100) || 0,
        color: "#c15ee8",
      },
    ];
    folders_structure_type = folders_structure_type.sort(
      (a, b) => b.count - a.count
    );
    setFolders_per_structure(folders_structure_type);
  };

  const handleFetchInfiltrea = async (orgData) => {
    let infiltrea_missions_filters = [
      {
        field: "master_id",
        operator: "==",
        value: orgData.id,
      },
    ];
    let missions_infiltrea = await queryCollection(
      "mission_infiltrea",
      infiltrea_missions_filters
    );
    // sort by the highest last_import_date
    missions_infiltrea = missions_infiltrea

      .filter((mission) => mission.last_import_date)
      .sort((a, b) => b.last_import_date - a.last_import_date);
    let last_infiltrea_reports_imported = missions_infiltrea;
    setLast_infiltrea_reports_imported(last_infiltrea_reports_imported);
  };

  useEffect(() => {
    handleFetchData(time_period, finalisation_time_error_correction); // Fetch user data when currentUser is available
  }, [orgData]); // Re-run when currentUser changes

  // Display loading message while checking authentication or fetching user data
  // If the data is still loading, show skeletons
  // loading || !currentUser || !userData
  if (loading) {
    return <></>;
  }

  if (loaded === false) {
    return (
      <div className="flex flex-col w-full h-full overflow-auto pl-4">
        <div className="text-h1 text-black mb-6 ">Statistiques</div>
        <div className="flex flex-row">
          {" "}
          <SmallSpinner />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full h-full overflow-auto pl-4 pb-10">
      <div className="text-hx font-medium text-black flex flex-row gap-4 items-center ">
        Statistiques
        <DropDownGPT0X
          className={"w-c200"}
          items={[
            {
              value: "last12months",
              label: "12 derniers mois",
            },
            {
              value: "thisyear",
              label: "Cette année",
            },
            {
              value: "lastyear",
              label: "L'année dernière",
            },
          ]}
          value={time_period}
          onChange={(e) => {
            setTime_period(e.value);
            handleFetchData(e.value, finalisation_time_error_correction);
          }}
        />
      </div>
      {loadingTime && <SmallSpinner />}
      <div className="flex flex-wrap gap-2  w-fit h-fit pr-5 py-5 justify-start items-start">
        <div className="flex flex-col  bg-white shadow-md shadow-blue-100 rounded-xl p-4  justify-between w-c400">
          <div className="flex flex-row justify-between text-shadow_50 ">
            <div className=" text-h3 flex flex-row   ">Dossiers</div>
            <div className=" text-h3 flex flex-row   ">
              {dict_stats.folders}
            </div>
          </div>
          <div className="flex flex-row justify-between text-shadow_50 ">
            <div className=" text-h3 flex flex-row   ">
              Temps moyen de finalisation
            </div>
            <div className=" text-h3 flex flex-row   ">
              {orgData.email === "rapport@ouestenergiecontrole.fr"
                ? 16
                : dict_stats.avg_finalisation_days}{" "}
              jours
            </div>
          </div>
          {hasInfiltro(orgData) && (
            <>
              <div className="flex flex-row  justify-between text-shadow_50 ">
                <div className=" text-h3 flex flex-row  ">
                  Moyenne des tests
                </div>
                <div className=" text-h3 flex flex-row  ">
                  {Math.round(dict_stats.avg_test_value * 100) / 100}
                </div>
              </div>
              <div className="flex flex-row  justify-between text-shadow_50 ">
                <div className=" text-h3 flex flex-row  ">Taux de revisite</div>
                <div className=" text-h3 flex flex-row  ">
                  {Math.round(dict_stats.perc_revisite * 100) / 100}%
                </div>
              </div>{" "}
              <div className="flex flex-row  justify-between text-shadow_50 ">
                <div className=" text-h3 flex flex-row  ">
                  Revisites effectuées
                </div>
                <div className=" text-h3 flex flex-row  ">
                  {dict_stats.revision_count}
                </div>
              </div>
            </>
          )}
          <div
            className={`flex flex-row  justify-between  cursor-pointer mt-4 hover:text-black ${dict_stats.rdv_count > 0 ? "text-red-500" : "text-shadow_50"} `}
            onClick={handleGoRDVFolder}
          >
            <div className=" text-h3 flex flex-row  ">Demandes de RDV</div>
            <div className=" text-h3 flex flex-row  ">
              {dict_stats.rdv_count}
            </div>
          </div>{" "}
          <div
            className={`flex flex-row  justify-between  cursor-pointer hover:text-black ${dict_stats.notified_folders_count > 0 ? "text-red-500" : "text-shadow_50"} `}
            onClick={() => navigateWorkspace("/messages")}
          >
            <div className=" text-h3 flex flex-row  ">Messages non lus</div>
            <div className=" text-h3 flex flex-row  ">
              {dict_stats.notified_folders_count}
            </div>
          </div>
          <div
            className={`flex flex-row  justify-between  cursor-pointer hover:text-black ${dict_stats.late_folders_count > 0 ? "text-red-500" : "text-shadow_50"}`}
            onClick={handleGoLateFolder}
          >
            <div className=" text-h3 flex flex-row  ">Dossiers en retard</div>
            <div className=" text-h3 flex flex-row  ">
              {dict_stats.late_folders_count}
            </div>
          </div>
          <div
            className={`flex flex-row  justify-between  cursor-pointer hover:text-black  ${dict_stats.done_no_folder_devis > 0 ? "text-red-500" : "text-shadow_50"}`}
            onClick={() => navigateWorkspace("/invoices")}
          >
            <div className=" text-h3 flex flex-row  ">
              Devis signés sans dossier
            </div>
            <div className=" text-h3 flex flex-row  ">
              {dict_stats.done_no_folder_devis}
            </div>
          </div>
        </div>
        <div className="flex flex-col bg-white shadow-md shadow-blue-100 rounded-xl p-5 h-c225" style={{ width: 520 }}>
          <LineChart
            data={new_folders_per_month.map((item) => ({
              label: item.month.substring(0, 3),
              tooltipLabel: `${item.month} ${item.year}`,
              value: item.count,
            }))}
            title="Nouveaux dossiers par mois"
            color="#6366F1"
          />
        </div>
        <div className="flex flex-col bg-white shadow-md shadow-blue-100 rounded-xl p-5 h-c225" style={{ width: 520 }}>
          <LineChart
            data={intervention_per_month.map((item) => ({
              label: item.month.substring(0, 3),
              tooltipLabel: `${item.month} ${item.year}`,
              value: item.count,
            }))}
            title="Interventions par mois"
            color="#6366F1"
          />
        </div>
        <div className="flex flex-col  bg-white shadow-md shadow-blue-100 rounded-xl p-5 h-c225">
          <div className="text-shadow_50 text-h3 flex flex-row justify-start mb-auto">
            Paiements par mois{" "}
            <span className="text-indigo-500 ml-auto">- total</span>{" "}
            <span className="text-indigo-200 ml-2"> - bridge</span>
          </div>
          <div className="flex flex-row ">
            {payments_per_month.map((item, index) => (
              <div
                key={index}
                className="flex flex-col  text-h5 w-c40 items-center"
              >
                <div
                  className="bg-indigo-500 rounded-sm w-3 mt-auto mb-1 relative"
                  style={{
                    height: valueNanCheck(item.height),
                  }}
                >
                  <div
                    className="absolute bottom-0 left-0 right-0 w-3"
                    style={{
                      height: valueNanCheck(item.bridge_height),
                      backgroundColor: "rgba(255, 255, 255, 0.5)",
                    }}
                  ></div>
                </div>
                <div className="my-1 text-indigo-500 text-h3">
                  {item.count > 0 ? (
                    Math.round(item.count / 100) / 10 + "k"
                  ) : (
                    <></>
                  )}
                </div>
                <div className="text-h6">{item.month.substring(0, 3)}</div>{" "}
                <div className="text-h7 font-semibold text-shadow_25">
                  {item.year}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col  bg-white shadow-md shadow-blue-100 rounded-xl p-5 h-c225">
          <div className="text-shadow_50 text-h3 flex flex-row justify-between mb-auto items-center">
            Temps moyen de finalisation par mois
            <div className="flex flex-row gap-2 ">
              <Tippy
                content="Ignore 15% des valeurs les plus élevées pour compenser les erreurs statistiques"
                delay={100}
                className="custom-tooltip"
              >
                <div className="text-indigo-400 text-h4">Correction</div>
              </Tippy>

              <EasySwitch
                checked={finalisation_time_error_correction === 0.85}
                onChange={() => {
                  let new_correction =
                    finalisation_time_error_correction === 0.85 ? 1 : 0.85;
                  setFinalisation_time_error_correction(new_correction);
                  handleFetchData(time_period, new_correction);
                }}
              ></EasySwitch>
            </div>
          </div>
          <div className="flex flex-row ">
            {finalisation_time_per_month.map((item, index) => (
              <div
                key={index}
                className="flex flex-col  text-h5 w-c40 items-center"
              >
                <div className="flex flex-row gap-1  mt-auto items-end">
                  <div
                    className="bg-indigo-500 rounded-sm w-3  mb-1"
                    style={{
                      height: valueNanCheck(item.height_time),
                    }}
                  ></div>
                </div>
                <div className="mb-1 text-indigo-500 text-h3">
                  {item.count_time}j
                </div>{" "}
                <div className="text-h6 ">{item.month.substring(0, 3)}</div>
                <div className="text-h7 font-semibold text-shadow_25">
                  {item.year}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col  bg-white shadow-md shadow-blue-100 rounded-xl p-5 h-c225">
          <div className="text-shadow_50 text-h3 flex flex-row justify-between mb-auto">
            Derniers dossiers finalisés
          </div>
          <div className="flex flex-col items-start mt-4 ">
            {last_finalised_folders.map((item, index) => (
              <div
                key={index}
                onClick={() => navigateWorkspace(`/folder/${item.id}`)}
                className="flex flex-row gap-4  text-h5 items-center cursor-pointer hover:font-semibold"
              >
                <div className=" text-indigo-500 w-c200 ">{item.nom}</div>{" "}
                <div className=" text-neutral-400 w-c125 ">
                  {new Date(
                    item.finalised_date?.seconds * 1000
                  ).toLocaleString()}
                </div>{" "}
                <div className=" text-indigo-300  ">
                  {item.dateintervention?.seconds
                    ? (
                        (item.finalised_date?.seconds -
                          item.dateintervention?.seconds) /
                        (60 * 60 * 24)
                      ).toFixed(0)
                    : "?"}{" "}
                  jours
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col  bg-white shadow-md shadow-blue-100 rounded-xl p-5 h-c225">
          <div className="text-shadow_50 text-h3 flex flex-row justify-between  mb-auto">
            Contrôles par opérateur (appli)
          </div>
          <div className="flex flex-row ">
            {control_per_operator.map((item, index) => (
              <div
                key={index}
                className="flex flex-col  text-h5 w-c40 items-center"
              >
                <div
                  className="bg-indigo-500 rounded-sm w-3 mt-auto mb-1"
                  style={{
                    height: valueNanCheck(item.height),
                  }}
                ></div>
                <div className="my-1 text-indigo-500 text-h2">{item.count}</div>
                <Tippy
                  content={item.name}
                  delay={100}
                  className="custom-tooltip"
                >
                  <div className="text-h6">{item.name.substring(0, 4)}</div>
                </Tippy>
              </div>
            ))}
          </div>
        </div>{" "}
        <div className="flex flex-col  bg-white shadow-md shadow-blue-100 rounded-xl p-5 h-c225">
          <div className="text-shadow_50 text-h3 flex flex-row justify-between  mb-auto">
            Répartition des dossiers en cours
          </div>
          <div className="flex flex-row ">
            {repartition_folders.map((item, index) => (
              <div
                key={index}
                className="flex flex-col  text-h5 w-c40 items-center"
              >
                <div
                  className="bg-indigo-500 rounded-sm w-3 mt-auto mb-1"
                  style={{
                    height: valueNanCheck(item.height),
                    backgroundColor: item.color,
                  }}
                ></div>
                <div className="my-1 text-indigo-500 text-h2">{item.count}</div>
                <Tippy
                  content={item.title}
                  delay={100}
                  className="custom-tooltip"
                >
                  <div className="text-h6">{item.title.substring(0, 5)}</div>
                </Tippy>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col  bg-white shadow-md shadow-blue-100 rounded-xl p-5 h-c225">
          <div className="text-shadow_50 text-h3 flex flex-row justify-between  mb-auto">
            Dossiers par types de clients
          </div>
          <div className="flex flex-row ">
            {folders_client_type.map((item, index) => (
              <div
                key={index}
                className="flex flex-col  text-h5 w-c40 items-center"
              >
                <div
                  className="bg-indigo-500 rounded-sm w-3 mt-auto mb-1"
                  style={{
                    height: valueNanCheck(item.height),
                    backgroundColor: item.color,
                  }}
                ></div>
                <div className="my-1 text-indigo-500 text-h2">{item.count}</div>
                <Tippy
                  content={item.title}
                  delay={100}
                  className="custom-tooltip"
                >
                  <div className="text-h6">{item.title.substring(0, 5)}</div>
                </Tippy>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col  bg-white shadow-md shadow-blue-100 rounded-xl p-5 h-c225">
          <div className="text-shadow_50 text-h3 flex flex-row justify-between  mb-auto">
            Création des dossiers
          </div>
          <div className="flex flex-row ">
            {folders_origin.map((item, index) => (
              <div
                key={index}
                className="flex flex-col  text-h5 w-c40 items-center"
              >
                <div
                  className="bg-indigo-500 rounded-sm w-3 mt-auto mb-1"
                  style={{
                    height: valueNanCheck(item.height),
                    backgroundColor: item.color,
                  }}
                ></div>
                <div className="my-1 text-indigo-500 text-h2">{item.count}</div>
                <Tippy
                  content={item.title}
                  delay={100}
                  className="custom-tooltip"
                >
                  <div className="text-h6">{item.title.substring(0, 5)}</div>
                </Tippy>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col  bg-white shadow-md shadow-blue-100 rounded-xl p-5 h-fit min-h-c225">
          <div className="text-shadow_50 text-h3 flex flex-row justify-between  mb-auto">
            Dossiers par clients
            <div
              className="cursor-pointer"
              onClick={() => setShow_all_clients(!show_all_clients)}
            >
              <Icon1
                icon_name="full-screen"
                size={16}
                fill={infiltreaSize ? "lightgrey" : "grey"}
              ></Icon1>
            </div>{" "}
          </div>
          <div className="flex flex-wrap gap-y-2">
            {folders_per_client
              .slice(0, show_all_clients ? 100 : 9)
              .map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col  text-h5 w-c40 items-center"
                >
                  <div
                    className="bg-indigo-500 rounded-sm w-3 mt-auto mb-1"
                    style={{
                      height: valueNanCheck(item.height),
                    }}
                  ></div>
                  <div className="my-1 text-indigo-500 text-h2">
                    {item.count}
                  </div>
                  <Tippy
                    content={item.name}
                    delay={100}
                    className="custom-tooltip"
                  >
                    <div className="text-h6 ">{item.name.substring(0, 4)}</div>
                  </Tippy>
                </div>
              ))}
          </div>
        </div>{" "}
        <div className="flex flex-col  bg-white shadow-md shadow-blue-100 rounded-xl p-5 h-c225">
          <div className="text-shadow_50 text-h3 flex flex-row justify-between  mb-auto">
            Dossiers par type de structure
          </div>
          <div className="flex flex-row ">
            {folders_per_structure.map((item, index) => (
              <div
                key={index}
                className="flex flex-col  text-h5 w-c40 items-center"
              >
                <div
                  className="bg-indigo-500 rounded-sm w-3 mt-auto mb-1"
                  style={{
                    height: valueNanCheck(item.height),
                  }}
                ></div>
                <div className="my-1 text-indigo-500 text-h2">{item.count}</div>
                <Tippy
                  content={item.name}
                  delay={100}
                  className="custom-tooltip"
                >
                  <div className="text-h6 ">{item.name?.substring(0, 4)}</div>
                </Tippy>
              </div>
            ))}
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default MasterStats;

export function valueNanCheck(value) {
  if (isNaN(value) || value === null) {
    return 0;
  }
  return value;
}
